module.exports = __webpack_public_path__ + "static/img/logo (1).47c9d75.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo (1).png
// module id = 8K8P
// module chunks = 3